import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { bridgeCombo, initialState } from 'app/core/models/slice/com/brigeCombo'
import { RootState } from 'app/core/store'

const slice = createSlice({
    name: 'bridgeCombo',
    initialState,
    reducers: {
        /* 초기화 */
        clearBridgeCombo: (state) => {
            state = { ...initialState }
        },
        /* 외부 진입 링크 param 저장 */
        setBridgeCombo: (state, action: PayloadAction<bridgeCombo>) => {
            state = { ...action.payload }
        },
        /* 부점코드 저장 */
        setBrcd: (state, action: PayloadAction<string>) => {
            state.brcd = action.payload
        },
        /* 직원번호 저장 */
        setEmn: (state, action: PayloadAction<string>) => {
            state.emn = action.payload
        },
        /* 조회목적코드 저장 */
        setCbinqObjtCd: (state, action: PayloadAction<string>) => {
            state.cbinqObjtCd = action.payload
        },
        /* 전행고객번호 저장 */
        setCsn: (state, action: PayloadAction<string>) => {
            state.csn = action.payload
        },
        /* 상품구분코드 저장 */
        setGubun: (state, action: PayloadAction<string>) => {
            state.gubun = action.payload
        },
        /* 제휴사코드 저장 */
        setAcd: (state, action: PayloadAction<string>) => {
            state.acd = action.payload
        },
        /* 비대면상품구분코드 저장 */
        setGrpcd: (state, action: PayloadAction<string>) => {
            state.grpcd = action.payload
        },
        /* 제휴처 코드 저장 */
        setAlplDcd: (state, action: PayloadAction<string>) => {
            state.alplDcd = action.payload
        },
        /* 상품코드 저장 */
        setApcd: (state, action: PayloadAction<string>) => {
            state.apcd = action.payload
        },
        /* ??? 저장 */
        setNstationSubparam: (state, action: PayloadAction<string>) => {
            state.nstationSubparam = action.payload
        },
    },
})

export const {
    clearBridgeCombo,
    setBridgeCombo,
    setAcd,
    setAlplDcd,
    setApcd,
    setBrcd,
    setCbinqObjtCd,
    setCsn,
    setEmn,
    setGrpcd,
    setGubun,
    setNstationSubparam,
} = slice.actions

export default slice.reducer

export const selectBridgeCombo = (state: RootState) => {
    return { ...state.bridgeCombo }
}
